import { useState, useEffect } from "react";
import { toast } from "sonner";
import QRCode from "qrcode";
import api from "../lib/api";
import { Gift, Copy, Share2, QrCode } from "lucide-react";
import { isNoldDomain } from "../lib/domain";

// QR de parrainage livreur / chauffeur — généré automatiquement dès la validation du profil.
// Réutilise l'endpoint `/api/referral` déjà utilisé côté passager pour rester DRY.
export function DriverReferralQR({ approved, isEuropeDriver }) {
  const [data, setData] = useState(null);
  const [qr, setQr] = useState("");

  useEffect(() => {
    if (!approved) return;
    let ok = true;
    api.get("/referral").then((r) => {
      if (!ok) return;
      setData(r.data);
      const origin = typeof window !== "undefined" ? window.location.origin : "";
      const link = `${origin}/auth?role=passenger&ref=${r.data.code}`;
      QRCode.toDataURL(link, { width: 260, margin: 1, color: { dark: "#1A1A1A", light: "#FFFFFF" } })
        .then(setQr).catch(() => {});
    }).catch(() => {});
    return () => { ok = false; };
  }, [approved]);

  if (!approved || !data) return null;

  const noldMode = isNoldDomain() || isEuropeDriver;
  const link = `${window.location.origin}/auth?role=passenger&ref=${data.code}`;
  const copy = async () => { try { await navigator.clipboard.writeText(link); toast.success("Lien copié ✓"); } catch { toast.error("Impossible de copier"); } };
  const share = async () => {
    const msg = noldMode
      ? `🚴‍♂️ Rejoins Nold Go et commande ta première livraison de repas ! Utilise mon code ${data.code} 👉 ${link}`
      : `🛵 Rejoins BentSkin Go ! Utilise mon code ${data.code} 👉 ${link}`;
    if (navigator.share) { try { await navigator.share({ title: noldMode ? "Nold Go" : "BentSkin Go", text: msg, url: link }); } catch { /* cancelled */ } }
    else copy();
  };

  return (
    <div className="mt-4 bg-white rounded-3xl border border-[#E2DFD8] p-6" data-testid="driver-referral-qr">
      <h3 className="font-head font-bold text-base flex items-center gap-2">
        <Gift className="w-5 h-5 text-[#F26419]" /> Mon parrainage
      </h3>
      <p className="text-xs text-[#75807A] mt-1">
        Partagez votre QR ou votre code : vous gagnez un bonus dès la 1ère course de votre filleul.
      </p>
      <div className="mt-4 flex flex-col sm:flex-row items-center gap-4">
        {qr && <img data-testid="referral-qr-img" src={qr} alt="QR parrainage" className="w-40 h-40 rounded-2xl border-2 border-[#E2DFD8] bg-white p-2 shrink-0" />}
        <div className="flex-1 min-w-0 w-full">
          <div className="text-xs text-[#75807A] font-medium">Votre code</div>
          <div data-testid="referral-code" className="font-head font-black text-2xl text-[#1A1A1A] tracking-wider">{data.code}</div>
          <div className="mt-2 text-xs text-[#75807A] break-all">{link}</div>
          <div className="mt-3 flex flex-wrap gap-2">
            <button data-testid="referral-copy" onClick={copy} className="inline-flex items-center gap-1.5 h-10 px-4 rounded-xl bg-[#F0EBE1] hover:bg-[#E2DFD8] text-[#1A1A1A] text-sm font-semibold">
              <Copy className="w-4 h-4" /> Copier
            </button>
            <button data-testid="referral-share" onClick={share} className="inline-flex items-center gap-1.5 h-10 px-4 rounded-xl bg-[#F26419] hover:bg-[#D85312] text-white text-sm font-semibold">
              <Share2 className="w-4 h-4" /> Partager
            </button>
          </div>
          <div className="mt-3 text-xs text-[#3B423E] flex items-center gap-1.5"><QrCode className="w-3.5 h-3.5 text-[#F26419]" /> Filleuls inscrits : <span className="font-bold">{data.referrals_count || 0}</span></div>
        </div>
      </div>
    </div>
  );
}
